import React from 'react';
import { motion } from 'framer-motion';
import './ProgressBar.css';

const ProgressBar = ({ progress = 0, stages = [] }) => {
  const currentStage = stages.find((stage, index) => 
    progress >= stage.minProgress && progress <= stage.maxProgress
  ) || stages[0];

  return (
    <div className="progress-container">
      <div className="progress-header">
        <h3>Creating Your Confession Token</h3>
        <div className="progress-percentage">{Math.round(progress)}%</div>
      </div>
      
      <div className="progress-bar-wrapper">
        <div className="progress-bar-track">
          <motion.div 
            className="progress-bar-fill"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          />
        </div>
      </div>
      
      {currentStage && (
        <motion.div 
          className="progress-stage"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          key={currentStage.label}
        >
          <div className="stage-icon">{currentStage.icon}</div>
          <div className="stage-text">
            <span className="stage-label">{currentStage.label}</span>
            <span className="stage-description">{currentStage.description}</span>
          </div>
        </motion.div>
      )}
      
      <div className="progress-stages-list">
        {stages.map((stage, index) => (
          <div 
            key={index}
            className={`stage-item ${progress >= stage.minProgress ? 'completed' : progress >= stage.minProgress - 5 ? 'active' : ''}`}
          >
            <div className="stage-marker">
              {progress >= stage.maxProgress ? '✓' : stage.icon}
            </div>
            <span className="stage-name">{stage.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;